"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecPurchase = void 0;
const enums_1 = require("../enums");
const getVariant_1 = require("../helper/getVariant");
const mapOrderProductToProduct_1 = require("../helper/mapOrderProductToProduct");
const interfaces_1 = require("../interfaces");
const buildEecPackagingProduct_1 = require("./buildEecPackagingProduct");
const buildEecProduct_1 = require("./buildEecProduct");
const buildGA4ProductDetail_1 = require("./buildGA4ProductDetail");
const calulateReportingScoreSum_1 = require("./calulateReportingScoreSum");
const pushToDataLayer_1 = require("./pushToDataLayer");
function buildCoupon(discount, items) {
    if (discount) {
        return discount.coupon?.campaignName || discount.campaign;
    }
    const firstItemWithDiscount = items.find(item => item.discount);
    return firstItemWithDiscount && firstItemWithDiscount.discount
        ? firstItemWithDiscount.discount.coupon?.campaignName ||
            firstItemWithDiscount.discount.campaign
        : undefined;
}
function buildDeliveryType(shippingMethod) {
    switch (shippingMethod) {
        case 'online':
            return 'PDF';
        case 'standard':
        case 'box_standard':
            return 'Standard';
        case 'express':
        case 'box_express':
            return 'Express';
        default:
            return '';
    }
}
function buildGA4EcommerceData({ order, coupon, tenant, offsetShare, orderDiscountRate, }) {
    const { orderId, items, total, shipping } = order;
    const ga4ProductItems = items.map(({ product: orderProduct, reservationId, locationId, quantity, }) => {
        const product = (0, mapOrderProductToProduct_1.mapOrderProductToProduct)(orderProduct);
        const appointment = { reservationId, locationId };
        return (0, buildGA4ProductDetail_1.buildGA4ProductDetail)({
            product,
            variant: (0, getVariant_1.getVariant)(appointment, product.productType),
            quantity,
            appointment,
            tenant,
            offsetShare,
            orderDiscountRate,
        });
    });
    ga4ProductItems.push(...items
        .filter(item => item.packaging)
        .map(({ packaging, quantity }) => (0, buildEecPackagingProduct_1.buildGA4PackagingProductItem)({
        quantity,
        tenant,
        offsetShare,
        packaging,
    })));
    return {
        transaction_id: orderId,
        value: total.gross.amount,
        shipping: shipping.price.gross.amount,
        currency: total.gross.currencyCode,
        coupon,
        items: ga4ProductItems,
    };
}
function trackEecPurchase(order, tenant) {
    const { orderId, items, total, shipping, discount, discountTotal, paymentVouchers } = order;
    const { amount, currencyCode } = total.gross;
    const shippingPrice = shipping.price.gross.amount;
    const revenue = Math.max(amount, 0);
    const paymentVouchersTotal = paymentVouchers.reduce((prev, curr) => prev + curr.deductedAtPurchase.amount, 0);
    const offsetShare = paymentVouchersTotal === 0 ? 0 : paymentVouchersTotal / (amount + paymentVouchersTotal);
    const discountableItems = items.filter(item => interfaces_1.discountableProductTypes.includes(item.product.productType) &&
        !item.product.originalPrice);
    const discountableTotal = discountableItems.reduce((acc, item) => acc + item.product.price.gross.amount * item.quantity, 0);
    const orderDiscountRate = (discountTotal?.amount ?? 0) / discountableTotal;
    const eecProducts = items.map(({ product, quantity, reservationId, locationId }) => (0, buildEecProduct_1.buildEecProduct)({
        product: (0, mapOrderProductToProduct_1.mapOrderProductToProduct)(product),
        quantity,
        tenant,
        offsetShare,
        orderDiscountRate,
        appointment: {
            reservationId,
            locationId,
        },
    }));
    const packagingProducts = items
        .filter(item => item.packaging)
        .map(({ packaging, quantity }) => (0, buildEecPackagingProduct_1.buildEecPackagingProduct)({
        quantity,
        tenant,
        offsetShare,
        packaging,
    }));
    eecProducts.push(...packagingProducts);
    const reportingScoreSum = (0, calulateReportingScoreSum_1.calulateReportingScoreSum)({
        tenant,
        shippingPrice,
        offsetShare,
        products: eecProducts,
    });
    const coupon = buildCoupon(discount, items);
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: enums_1.EventName.EECPurchase,
        ecommerce: {
            currencyCode,
            purchase: {
                actionField: {
                    id: orderId,
                    revenue,
                    shipping: shippingPrice,
                    coupon,
                },
                products: eecProducts,
            },
        },
        deliveryType: buildDeliveryType(shipping.id),
        discountValue: discountTotal && discountTotal.amount > 0 ? discountTotal.amount : null,
        reportingScoreSum: Number(reportingScoreSum.toFixed(2)),
        ga4ecommerce: buildGA4EcommerceData({
            order,
            coupon,
            tenant,
            offsetShare,
            orderDiscountRate,
        }),
    });
}
exports.trackEecPurchase = trackEecPurchase;
//# sourceMappingURL=trackEecPurchase.js.map